module.exports = __webpack_public_path__ + "static/media/falcon_armor.eea5443f.png";